var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-simple-table',{attrs:{"dense":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.label},[_c('td',[_vm._v(_vm._s(item.label))]),_c('td',[_vm._v(_vm._s(item.value))])])}),0)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }